import React, { useEffect, useState } from 'react'

import { Tooltip } from '@material-ui/core'
import {
  sanitizeListRestProps,
  TopToolbar,
  useTranslate,
  useLocale,
} from 'react-admin'

import tracker from '../../utils/tracker'
import { CreateActionButton } from './createActionButton'
import { ExportInvoiceActionButton } from './exportInvoiceActionButton'

export const InvoiceActions = (props) => {
  const translate = useTranslate()
  const locale = useLocale()
  const [tooltipVisibility, setTooltipVisibility] = useState(true)

  useEffect(() => {
    setTooltipVisibility(false)
  }, [locale])

  useEffect(() => {
    if (!tooltipVisibility) setTooltipVisibility(true)
  }, [tooltipVisibility])

  const {
    className,
    basePath,
    hasShow,
    hasEdit,
    hasList,
    linkDataCreditLines,
    ...rest
  } = props

  const handleClick = () => {
    tracker.event({
      action: 'invoice_advance_request_button_clicked',
      category: 'invoiceAdvanceRequest',
      label: props.filterValues
        ? props.filterValues.tabName !== undefined
          ? props.filterValues.tabName.toLowerCase()
          : undefined
        : undefined,
    })
  }

  let exportOptions = [
    {
      id: '',
      name: translate('resources.invoices.actions.export.all'),
    },
  ]
  exportOptions = exportOptions.concat(
    linkDataCreditLines
      ? linkDataCreditLines.map((item) => ({
          id: item.id,
          name: item.importerName,
        }))
      : []
  )

  const handleExport = (id) => {
    tracker.event({
      action: 'advances_export_clicked',
      category: 'export',
      label: 'optionSelected',
      value: !id ? 'allBuyers' : 'singleBuyer',
    })
  }

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {props.showExport && (
        <ExportInvoiceActionButton
          basePath={basePath}
          label="resources.invoices.actions.export.name"
          fields={exportOptions}
          onExport={handleExport}
        />
      )}
      {tooltipVisibility && (
        <Tooltip title={translate('resources.invoices.actions.create.nameAlt')}>
          <CreateActionButton
            basePath={basePath}
            label="resources.invoices.actions.create.name"
            onClick={handleClick}
          />
        </Tooltip>
      )}
    </TopToolbar>
  )
}
